import { Component, inject, viewChild, ChangeDetectionStrategy } from '@angular/core';
import { BaseDialogComponent } from '../../../../../components/kit/base-dialog/base-dialog.component';
import { contentGlobalSuccess } from '../../../../content/content.error';
import { ButtonComponent } from '../../../../../components/kit/button/button.component';
import { FileUpload, FileUploadModule } from '@openng/optimus-ui/fileupload';
import { TranslatePipe } from '@ngx-translate/core';
import { ActionButtonsComponent } from '../../../../../components/kit/action-buttons/action-buttons.component';
import { CsvImportSettingsDialogStore } from './csv-import-settings-dialog.store';
import { convertFileToBase64 } from '../../../../shared/helpers/file-download.helper';

@Component({
    selector: 'app-csv-import-settings-dialog',
    templateUrl: './csv-import-settings-dialog.component.html',
    styleUrl: './csv-import-settings-dialog.component.scss',
    imports: [
        ButtonComponent,
        FileUploadModule,
        TranslatePipe,
        ActionButtonsComponent,
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    providers: [CsvImportSettingsDialogStore]
})
export class CsvImportSettingsDialogComponent extends BaseDialogComponent {
    public readonly store = inject(CsvImportSettingsDialogStore);

    fileUpload = viewChild.required<FileUpload>('fu');
    protected organizationId;

    isValid = false;
    processing = false;

    constructor() {
        super();
        this.organizationId = this.dialogConfig.data.organizationId;
    }
    override async save() {
        if (!this.isValid) {
            return;
        }
        this.processing = true;
        const file = this.fileUpload().files[0];

        const base64data = await convertFileToBase64(file);
        if (!base64data) {
            this.processing = false;
            return;
        }
        const res = await this.store.api.importOrganizationSettings({
            organizationId: this.organizationId,
            base64data,
        })

        this.processing = false;
        if (res.ok) {
            contentGlobalSuccess.next('common.imported');
            this.dialogRef.close(true);
        }
    }

    onFileSelect(event: any): void {
        this.isValid = event.files && event.files.length > 0;
    }

    onFileClear(): void {
        this.isValid = false;
    }
}
